import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { OperatorLayer } from "../components/operator/OperatorLayer";

export const OperatorPage = () => {
  return (
    <MasterLayout>
      <OperatorLayer />
    </MasterLayout>
  );
};

export default OperatorPage;
